<template>
    <div id="challengeQuestion" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open && obj != null" class="questionPage container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto d-flex flex-column">
                    <div class="header justify-content-center mb-3">
                        <progress-bar type="circle" ref="circle" :options="progressOptions" class="timer animate__animated animate__zoomIn animate__faster"></progress-bar>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <h3 class="d-flex align-items-center vh-30">{{ obj.question.text }}</h3>

                    <ul class="answers">
                        <li @click="selectAnswer(a);btnSfx();" v-for="a in obj.question.answers" :key="a.id" :class="selectedId == a.id ? 'selected '+selectedClass : ''">
                            {{ a.text }}
                            <i class="fas fa-check-circle"></i><i class="fas fa-times-circle"></i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'

const AuctionQuestionPopup = Vue.component('auction-question-popup', {
    data() {
        return {
            open: false,
            auction: null,
            obj: null,
            lock: false,
            selectedId: null,
            selectedClass: "",

            progressOptions: {
                color: '#ff8500',
                trailColor: '#abccee',
                strokeWidth: 14,
                trailWidth: 14,
                from: { color: '#ff4e36' },
                to: { color: '#ff8500' },
                step: function(state, circle, attachment) {
                    circle.path.setAttribute('stroke', state.color);
                }
            }
        }
    },

    stopwatch: 0,
    timer: null,
    offset: null,

    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },

    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show(auction) {
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.auctionsQuestionnaire(auction.id)
              .then(res => {
                  loader.classList.remove("show");
                  
                  $this.obj = res.data;
                  $this.selectedId = null;
                  $this.selectedClass = "";
                  $this.open = true;
                  $this.auction = auction;
                  setTimeout(function(){  $this.setTimer(); }, 150);
              })
              .catch((error) => {
                loader.classList.remove("show");
                api.baseErrorHendler(error);
              });
        },

        hide() {
            this.open = false;
            this.obj = null;

            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }
            
            document.getElementById('loader').classList.remove("show");
        },

        selectAnswer(answer){
            if(this.selectedId != null) return;

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            this.selectedId = answer.id;

            if(this.timer != null){ 
                // update timer before stop - this increase precission
                this.stopwatch = performance.now() - this.offset;
                clearInterval(this.timer);
                this.timer = null;
            }

            let dt  = moment.duration(this.obj.timeout).valueOf();
            
            $this.$refs.circle.set((dt - this.stopwatch) / dt);
            $this.$refs.circle.setText(this.formatMilisecondTime(dt - this.stopwatch));
            
            let time = (this.stopwatch | 0);
            
            api.auctionsQuestionnaireAnswer(this.auction.id, this.selectedId, time)
                .then((response) => {
                    let obj = response.data;
                    $this.selectedClass = obj.answer.correct ? "correct" : "wrong";
                    setTimeout(function(){ 
                        if(obj.answer.correct) $this.$root.$emit("setHomeView", { view: 'auction-form', target: {...$this.auction}});
                        $this.$root.$emit("updateAuctionRequest", $this.auction);
                        $this.hide();
                    }, 1500);
                })
                .catch((error) => {
                    $this.selectedId = null;
                    api.baseErrorHendler(error);
                })
                .then(() => {
                    loader.classList.remove("show");
                });
        },

        formatMilisecondTime(time){
            return (time / 1000).toFixed(12).slice(0, 1 - 12)+"s";
        },

        setTimer(){
            const $this = this;
            if(this.timer != null){ 
                clearInterval(this.timer);
                this.timer = null;
            }

            this.offset = performance.now();
            this.stopwatch = 0;
            this.$refs.circle.setText("0s");
            this.$refs.circle.set(1);

            let sec = 0;
            let dt  = moment.duration(this.obj.timeout).valueOf();

            this.timer = setInterval(() => { 
                
                let now = performance.now(),
                    d   = now - $this.offset;

                $this.stopwatch = d;
                $this.$refs.circle.set((dt - $this.stopwatch) / dt);
                $this.$refs.circle.setText($this.formatMilisecondTime(dt - $this.stopwatch));

                if (dt - $this.stopwatch < 5000 && $this.selectedId == null && sec != (($this.stopwatch/1000) | 0))
                    $this.$store.dispatch('sound/sfx','Timer');

                sec = ($this.stopwatch/1000) | 0;

                if($this.stopwatch > dt){
                    clearInterval($this.timer);
                    $this.timer = null;
                    $this.hide();
                }

            }, 10);
        },

    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    }
})

export default AuctionQuestionPopup
</script>